import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from "classnames";
import { SketchPicker } from "react-color";
import { isNumber, noop, kebabCase, isPlainObject, isEqual } from "lodash";
import mathExpressionEvaluator from "math-expression-evaluator";
import React, { useContext, useState } from "react";
import { Field, change } from "redux-form";
import "./style.css";
import { InputGroup, NumericInput, Intent, RadioGroup, Checkbox, EditableText, Tooltip, Position, Switch, Classes, FormGroup, Button, TextArea, Popover } from "@blueprintjs/core";
import { DateInput, DateRangeInput } from "@blueprintjs/datetime";
import useDeepCompareEffect from "use-deep-compare-effect";
import { difference } from "lodash";
import { set } from "lodash";
import TgSelect from "../TgSelect";
import TgSuggest from "../TgSuggest";
import InfoHelper from "../InfoHelper";
import getDayjsFormatter from "../utils/getDayjsFormatter";
import AsyncValidateFieldSpinner from "../AsyncValidateFieldSpinner";
import { AssignDefaultsModeContext, WorkflowDefaultParamsContext, workflowDefaultParamsObj } from "../AssignDefaultsModeContext";
import popoverOverflowModifiers from "../utils/popoverOverflowModifiers";
import Uploader from "./Uploader";
import sortify from "./sortify";
import { fieldRequired } from "./utils";
export { fieldRequired };

function getIntent(_ref) {
  var showErrorIfUntouched = _ref.showErrorIfUntouched,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;
  var hasError = (touched || showErrorIfUntouched) && error;
  var hasWarning = (touched || showErrorIfUntouched) && warning;

  if (hasError) {
    return Intent.DANGER;
  } else if (hasWarning) {
    return Intent.WARNING;
  }
}

function getIntentClass() {
  var intent = getIntent.apply(void 0, arguments);

  if (intent === Intent.DANGER) {
    return Classes.INTENT_DANGER;
  } else if (intent === Intent.WARNING) {
    return Classes.INTENT_WARNING;
  } else {
    return "";
  }
}

function removeUnwantedProps(props) {
  var cleanedProps = _extends({}, props);

  delete cleanedProps.className;
  delete cleanedProps.units;
  delete cleanedProps.inlineLabel;
  delete cleanedProps.isLabelTooltip;
  delete cleanedProps.showErrorIfUntouched;
  delete cleanedProps.onChange;
  delete cleanedProps.containerStyle;
  delete cleanedProps.onFieldSubmit;
  delete cleanedProps.onBlur;
  delete cleanedProps.intent;
  delete cleanedProps.intentClass;
  delete cleanedProps.meta;
  delete cleanedProps.defaultValue;
  delete cleanedProps.enableReinitialize;
  delete cleanedProps.tabIndex;
  delete cleanedProps.secondaryLabel;
  delete cleanedProps.tooltipError;
  delete cleanedProps.tooltipInfo;
  delete cleanedProps.tooltipProps; // delete cleanedProps.asyncValidate;
  // delete cleanedProps.asyncValidating;
  // delete cleanedProps.validateOnChange;

  delete cleanedProps.hasCustomError;

  if (cleanedProps.inputClassName) {
    cleanedProps.className = cleanedProps.inputClassName;
    delete cleanedProps.inputClassName;
  }

  return cleanedProps;
}

function LabelWithTooltipInfo(_ref2) {
  var label = _ref2.label,
      tooltipInfo = _ref2.tooltipInfo,
      labelStyle = _ref2.labelStyle;
  return tooltipInfo ? /*#__PURE__*/React.createElement("div", {
    style: _extends({
      display: "flex",
      alignItems: "center"
    }, labelStyle)
  }, label, " ", /*#__PURE__*/React.createElement(InfoHelper, {
    style: {
      marginLeft: "5px",
      marginTop: "-6px"
    },
    size: 12,
    content: tooltipInfo
  })) : label || null;
}

var AbstractInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AbstractInput, _React$Component);

  function AbstractInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "updateDefaultValue", function () {
      var _this$props = _this.props,
          defaultValue = _this$props.defaultValue,
          name = _this$props.input.name,
          _this$props$meta = _this$props.meta,
          dispatch = _this$props$meta.dispatch,
          form = _this$props$meta.form,
          onDefaultValChanged = _this$props.onDefaultValChanged,
          onFieldSubmit = _this$props.onFieldSubmit;
      dispatch(change(form, name, defaultValue));
      onDefaultValChanged && onDefaultValChanged(defaultValue, name, form, _this.props);
      onFieldSubmit && onFieldSubmit(defaultValue);
    });

    return _this;
  }

  var _proto = AbstractInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props2 = this.props,
        defaultValue = _this$props2.defaultValue,
        enableReinitialize = _this$props2.enableReinitialize,
        value = _this$props2.input.value;

    if ((value !== false && !value || enableReinitialize) && defaultValue !== undefined) {
      this.updateDefaultValue();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(oldProps) {
    var oldDefaultValue = oldProps.defaultValue,
        oldDefaultValCount = oldProps.defaultValCount;
    var _this$props3 = this.props,
        defaultValue = _this$props3.defaultValue,
        defaultValCount = _this$props3.defaultValCount,
        enableReinitialize = _this$props3.enableReinitialize,
        value = _this$props3.input.value;

    if ((value !== false && !value || enableReinitialize || defaultValCount !== oldDefaultValCount) && !isEqual(defaultValue, oldDefaultValue)) {
      this.updateDefaultValue();
    }
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        children = _this$props4.children,
        tooltipProps = _this$props4.tooltipProps,
        tooltipError = _this$props4.tooltipError,
        disabled = _this$props4.disabled,
        intent = _this$props4.intent,
        tooltipInfo = _this$props4.tooltipInfo,
        label = _this$props4.label,
        inlineLabel = _this$props4.inlineLabel,
        isLabelTooltip = _this$props4.isLabelTooltip,
        secondaryLabel = _this$props4.secondaryLabel,
        className = _this$props4.className,
        showErrorIfUntouched = _this$props4.showErrorIfUntouched,
        asyncValidating = _this$props4.asyncValidating,
        meta = _this$props4.meta,
        containerStyle = _this$props4.containerStyle,
        leftEl = _this$props4.leftEl,
        rightEl = _this$props4.rightEl,
        labelStyle = _this$props4.labelStyle,
        noOuterLabel = _this$props4.noOuterLabel,
        noMarginBottom = _this$props4.noMarginBottom,
        assignDefaultButton = _this$props4.assignDefaultButton,
        showGenerateDefaultDot = _this$props4.showGenerateDefaultDot,
        setAssignDefaultsMode = _this$props4.setAssignDefaultsMode,
        startAssigningDefault = _this$props4.startAssigningDefault,
        input = _this$props4.input,
        noFillField = _this$props4.noFillField,
        isRequired = _this$props4.isRequired,
        isLoadingDefaultValue = _this$props4.isLoadingDefaultValue;
    var touched = meta.touched,
        error = meta.error,
        warning = meta.warning; // if our custom field level validation is happening then we don't want to show the error visually

    var showError = (touched || showErrorIfUntouched) && error && !asyncValidating;
    var showWarning = (touched || showErrorIfUntouched) && warning;
    var componentToWrap = isLabelTooltip || tooltipError ? /*#__PURE__*/React.createElement(Tooltip, _extends({
      disabled: isLabelTooltip ? false : !showError,
      intent: isLabelTooltip ? "none" : error ? "danger" : "warning",
      content: isLabelTooltip ? label : error || warning,
      position: Position.TOP,
      modifiers: popoverOverflowModifiers
    }, tooltipProps), children) : children;
    var testClassName = "tg-test-" + kebabCase(input.name);

    if (noFillField) {
      componentToWrap = /*#__PURE__*/React.createElement("div", {
        className: "tg-no-fill-field"
      }, componentToWrap);
    }

    var helperText;

    if (!tooltipError) {
      if (showError) {
        helperText = error;
      } else if (showWarning) {
        helperText = warning;
      }
    } // if in a cypress test show message so that inputs will not be interactable


    if (window.Cypress && isLoadingDefaultValue) {
      return "Loading default value...";
    }

    var labelInfo = secondaryLabel;
    var hasOuterLabel = !noOuterLabel && !isLabelTooltip;

    if (isRequired && hasOuterLabel && label && !labelInfo) {
      labelInfo = "(required)";
    }

    return /*#__PURE__*/React.createElement(FormGroup, {
      className: classNames(className, testClassName, {
        "tg-flex-form-content": leftEl || rightEl,
        "tg-tooltipError": tooltipError,
        "tg-has-error": showError && error
      }),
      disabled: disabled,
      helperText: helperText,
      intent: intent,
      label: hasOuterLabel && /*#__PURE__*/React.createElement(LabelWithTooltipInfo, {
        labelStyle: labelStyle,
        label: label,
        tooltipInfo: tooltipInfo
      }),
      inline: inlineLabel,
      labelInfo: labelInfo,
      style: _extends({}, noMarginBottom && {
        marginBottom: 0
      }, containerStyle)
    }, showGenerateDefaultDot && /*#__PURE__*/React.createElement("div", {
      style: {
        zIndex: 10,
        position: "relative",
        height: 0,
        width: 0
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        left: "0px",
        top: "0px"
      }
    }, /*#__PURE__*/React.createElement(Tooltip, {
      modifiers: popoverOverflowModifiers,
      content: "Allows a Default to be Set. Click to Enter Set Default Mode (or press Shift+D when outside the input field)"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        setAssignDefaultsMode(true);
        startAssigningDefault();
      },
      className: "generateDefaultDot"
    })))), assignDefaultButton, leftEl, " ", componentToWrap, " ", rightEl);
  };

  return AbstractInput;
}(React.Component);

export var renderBlueprintDateInput = function renderBlueprintDateInput(props) {
  var input = props.input,
      intent = props.intent,
      onFieldSubmit = props.onFieldSubmit,
      inputProps = props.inputProps,
      rest = _objectWithoutPropertiesLoose(props, ["input", "intent", "onFieldSubmit", "inputProps"]);

  return /*#__PURE__*/React.createElement(DateInput, _extends({}, getDayjsFormatter("L"), removeUnwantedProps(rest), {
    intent: intent,
    inputProps: inputProps
  }, input, {
    value: input.value ? new Date(input.value) : undefined,
    onChange: function onChange(selectedDate) {
      input.onChange(selectedDate);
      onFieldSubmit(selectedDate);
    }
  }));
};
export var renderBlueprintDateRangeInput = function renderBlueprintDateRangeInput(props) {
  var input = props.input,
      intent = props.intent,
      onFieldSubmit = props.onFieldSubmit,
      inputProps = props.inputProps,
      rest = _objectWithoutPropertiesLoose(props, ["input", "intent", "onFieldSubmit", "inputProps"]);

  return /*#__PURE__*/React.createElement(DateRangeInput, _extends({}, getDayjsFormatter("L"), removeUnwantedProps(rest), {
    intent: intent,
    inputProps: inputProps
  }, input, {
    value: input.value ? [new Date(input.value[0]), new Date(input.value[1])] : undefined,
    onChange: function onChange(selectedDate) {
      input.onChange(selectedDate);
      onFieldSubmit(selectedDate);
    }
  }));
};
export var RenderBlueprintInput = function RenderBlueprintInput(props) {
  var input = props.input,
      intent = props.intent,
      onFieldSubmit = props.onFieldSubmit,
      _props$onKeyDown = props.onKeyDown,
      _onKeyDown = _props$onKeyDown === void 0 ? noop : _props$onKeyDown,
      asyncValidating = props.asyncValidating,
      rightElement = props.rightElement,
      clickToEdit = props.clickToEdit,
      rest = _objectWithoutPropertiesLoose(props, ["input", "intent", "onFieldSubmit", "onKeyDown", "asyncValidating", "rightElement", "clickToEdit"]);

  var _useState = useState(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var _useState2 = useState(null),
      value = _useState2[0],
      setVal = _useState2[1];

  var toSpread = {};

  if (clickToEdit) {
    var isDisabled = clickToEdit && !isOpen;
    toSpread.disabled = rest.disabled || isDisabled;
  }

  var stopEdit = function stopEdit() {
    setOpen(false);
    setVal(null);
  };

  var inner = clickToEdit && !isOpen ? /*#__PURE__*/React.createElement("div", null, input.value) : /*#__PURE__*/React.createElement(InputGroup, _extends({
    rightElement: asyncValidating ? /*#__PURE__*/React.createElement(AsyncValidateFieldSpinner, {
      validating: true
    }) : rightElement
  }, removeUnwantedProps(rest), {
    intent: intent
  }, input, toSpread, clickToEdit ? _extends({
    disabled: rest.disabled,
    onChange: function onChange(e) {
      setVal(e.target.value);
    }
  }, value === null ? {} : {
    value: value
  }, {
    onKeyDown: function onKeyDown() {
      _onKeyDown.apply(void 0, arguments);

      var e = arguments.length <= 0 ? undefined : arguments[0];

      if (e.key === "Enter") {
        input.onChange(value === null ? input.value : value);
        onFieldSubmit(e.target.value, {
          enter: true
        }, e);
        stopEdit();
      }

      return true;
    }
  }) : {
    onKeyDown: function onKeyDown() {
      _onKeyDown.apply(void 0, arguments);

      var e = arguments.length <= 0 ? undefined : arguments[0];

      if (e.key === "Enter") {
        onFieldSubmit(e.target.value, {
          enter: true
        }, e);
      }
    },
    onBlur: function onBlur(e, val) {
      if (rest.readOnly) return;
      input.onBlur(e, val);
      onFieldSubmit(e.target ? e.target.value : val, {
        blur: true
      }, e);
    }
  }));
  if (clickToEdit) return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex"
    }
  }, inner, clickToEdit && (isOpen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    icon: "small-cross",
    onClick: stopEdit,
    intent: "danger"
  }), /*#__PURE__*/React.createElement(Button, {
    icon: "small-tick",
    onClick: function onClick() {
      input.onChange(value === null ? input.value : value);
      onFieldSubmit(value === null ? input.value : value, {
        cmdEnter: true
      });
      stopEdit();
    },
    intent: "success"
  }), " ") : /*#__PURE__*/React.createElement(Button, {
    minimal: true,
    onClick: function onClick() {
      setOpen(true);
    },
    icon: "edit"
  })));
  return inner;
};
export var renderBlueprintCheckbox = function renderBlueprintCheckbox(props) {
  var input = props.input,
      label = props.label,
      tooltipInfo = props.tooltipInfo,
      beforeOnChange = props.beforeOnChange,
      onFieldSubmit = props.onFieldSubmit,
      rest = _objectWithoutPropertiesLoose(props, ["input", "label", "tooltipInfo", "beforeOnChange", "onFieldSubmit"]);

  return /*#__PURE__*/React.createElement(Checkbox, _extends({}, removeUnwantedProps(rest), input, {
    checked: input.value,
    label: /*#__PURE__*/React.createElement(LabelWithTooltipInfo, {
      label: label,
      tooltipInfo: tooltipInfo
    }),
    onChange: getCheckboxOrSwitchOnChange({
      beforeOnChange: beforeOnChange,
      input: input,
      onFieldSubmit: onFieldSubmit
    })
  }));
};

var getCheckboxOrSwitchOnChange = function getCheckboxOrSwitchOnChange(_ref3) {
  var beforeOnChange = _ref3.beforeOnChange,
      input = _ref3.input,
      onFieldSubmit = _ref3.onFieldSubmit;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, val) {
      var v, _ref5, stopEarly;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              v = e.target ? e.target.checked : val;

              if (!beforeOnChange) {
                _context.next = 12;
                break;
              }

              _context.next = 4;
              return beforeOnChange(v, e);

            case 4:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 7;
                break;
              }

              _context.t0 = {};

            case 7:
              _ref5 = _context.t0;
              stopEarly = _ref5.stopEarly;

              if (!stopEarly) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              set(e, "target.checked", v);

            case 12:
              input.onChange(e, val);
              onFieldSubmit(v);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

export var renderBlueprintSwitch = function renderBlueprintSwitch(props) {
  var input = props.input,
      label = props.label,
      tooltipInfo = props.tooltipInfo,
      onFieldSubmit = props.onFieldSubmit,
      beforeOnChange = props.beforeOnChange,
      rest = _objectWithoutPropertiesLoose(props, ["input", "label", "tooltipInfo", "onFieldSubmit", "beforeOnChange"]);

  return /*#__PURE__*/React.createElement(Switch, _extends({}, removeUnwantedProps(rest), input, {
    checked: input.value,
    label: /*#__PURE__*/React.createElement(LabelWithTooltipInfo, {
      label: label,
      tooltipInfo: tooltipInfo
    }),
    onChange: getCheckboxOrSwitchOnChange({
      beforeOnChange: beforeOnChange,
      input: input,
      onFieldSubmit: onFieldSubmit
    })
  }));
};
export var renderFileUpload = function renderFileUpload(props) {
  var input = props.input,
      onFieldSubmit = props.onFieldSubmit,
      rest = _objectWithoutPropertiesLoose(props, ["input", "onFieldSubmit"]);

  return /*#__PURE__*/React.createElement(Uploader, _extends({
    fileList: input.value,
    onFieldSubmit: onFieldSubmit
  }, rest, {
    onChange: input.onChange
  }));
};
export var renderBlueprintTextarea = /*#__PURE__*/function (_React$Component2) {
  _inheritsLoose(renderBlueprintTextarea, _React$Component2);

  function renderBlueprintTextarea() {
    var _this2;

    for (var _len2 = arguments.length, _args2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      _args2[_key2] = arguments[_key2];
    }

    _this2 = _React$Component2.call.apply(_React$Component2, [this].concat(_args2)) || this;

    _defineProperty(_assertThisInitialized(_this2), "state", {
      value: null,
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this2), "allowEdit", function () {
      _this2.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "stopEdit", function () {
      _this2.setState({
        isOpen: false
      });

      _this2.setState({
        value: null
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "updateVal", function (e) {
      _this2.setState({
        value: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleValSubmit", function () {
      _this2.props.input.onChange(_this2.state.value === null ? _this2.props.input.value : _this2.state.value);

      _this2.props.onFieldSubmit(_this2.state.value === null ? _this2.props.input.value : _this2.state.value, {
        cmdEnter: true
      });

      _this2.stopEdit();
    });

    _defineProperty(_assertThisInitialized(_this2), "onKeyDown", function () {
      var e = arguments.length <= 0 ? undefined : arguments[0];
      (_this2.props.onKeyDown || noop).apply(void 0, arguments);

      if (e.keyCode === 13 && (e.metaKey || e.ctrlKey)) {
        _this2.props.onFieldSubmit(e.target.value, {
          cmdEnter: true
        }, e);

        _this2.props.input.onChange(e);

        _this2.stopEdit();
      }
    });

    return _this2;
  }

  var _proto2 = renderBlueprintTextarea.prototype;

  _proto2.render = function render() {
    var _this$props5 = this.props,
        input = _this$props5.input,
        intentClass = _this$props5.intentClass,
        inputClassName = _this$props5.inputClassName,
        onFieldSubmit = _this$props5.onFieldSubmit,
        clickToEdit = _this$props5.clickToEdit,
        _onKeyDown2 = _this$props5.onKeyDown,
        disabled = _this$props5.disabled,
        rest = _objectWithoutPropertiesLoose(_this$props5, ["input", "intentClass", "inputClassName", "onFieldSubmit", "clickToEdit", "onKeyDown", "disabled"]);

    if (clickToEdit) {
      var isDisabled = clickToEdit && !this.state.isOpen;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextArea, _extends({}, removeUnwantedProps(rest), {
        disabled: rest.disabled || isDisabled,
        className: classNames(intentClass, inputClassName, Classes.INPUT, Classes.FILL),
        value: this.state.value === null ? input.value : this.state.value,
        onChange: this.updateVal,
        onKeyDown: this.onKeyDown
      })), clickToEdit && !disabled && (this.state.isOpen ?
      /*#__PURE__*/
      //show okay/cancel buttons
      React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.stopEdit,
        intent: "danger"
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        onClick: this.handleValSubmit,
        intent: "success"
      }, "Ok")) :
      /*#__PURE__*/
      //show click to edit button
      React.createElement(Button, {
        onClick: this.allowEdit
      }, "Edit")));
    } else {
      return /*#__PURE__*/React.createElement(TextArea, _extends({}, removeUnwantedProps(rest), {
        disabled: disabled,
        className: classNames(intentClass, inputClassName, Classes.INPUT, Classes.FILL)
      }, input, {
        onBlur: function onBlur(e, val) {
          if (rest.readOnly) return;
          input.onBlur(e, val);
          onFieldSubmit(e.target ? e.target.value : val, {
            blur: true
          }, e);
        },
        onKeyDown: function onKeyDown() {
          var e = arguments.length <= 0 ? undefined : arguments[0];

          (_onKeyDown2 || noop).apply(void 0, arguments);

          if (e.keyCode === 13 && (e.metaKey || e.ctrlKey)) {
            onFieldSubmit(e.target.value, {
              cmdEnter: true
            }, e);
          }
        }
      }));
    }
  };

  return renderBlueprintTextarea;
}(React.Component); // class ClickToEditWrapper extends React.Component {
//   state = { isEditing: false };
//   render() {
//     return <div />;
//   }
// }

export var renderBlueprintEditableText = function renderBlueprintEditableText(props) {
  var input = props.input,
      onFieldSubmit = props.onFieldSubmit,
      rest = _objectWithoutPropertiesLoose(props, ["input", "onFieldSubmit"]);

  return /*#__PURE__*/React.createElement(EditableText, _extends({}, removeUnwantedProps(rest), input, {
    onConfirm: function onConfirm(value) {
      input.onBlur && input.onBlur(value);
      onFieldSubmit(value, {
        input: input,
        meta: rest.meta
      });
    }
  }));
};
export var renderReactSelect = function renderReactSelect(props) {
  // spreading input not working, grab the values needed instead
  var async = props.async,
      _props$input = props.input,
      value = _props$input.value,
      _onChange = _props$input.onChange,
      hideValue = props.hideValue,
      intent = props.intent,
      options = props.options,
      onFieldSubmit = props.onFieldSubmit,
      beforeOnChange = props.beforeOnChange,
      rest = _objectWithoutPropertiesLoose(props, ["async", "input", "hideValue", "intent", "options", "onFieldSubmit", "beforeOnChange"]);

  var optionsPassed = options;
  var optsToUse = getOptions(optionsPassed);
  var valueToUse;

  if (!Array.isArray(value) && typeof value === "object") {
    if (value.userCreated) {
      valueToUse = {
        label: value.value,
        value: value
      };
    } else {
      valueToUse = optsToUse.find(function (obj) {
        return isEqual(obj.value, value);
      });
    }
  } else if (Array.isArray(value)) {
    valueToUse = value.map(function (val) {
      if (val.userCreated) {
        return {
          label: val.value,
          value: val
        };
      }

      if (optsToUse) {
        return optsToUse.find(function (obj) {
          return isEqual(obj.value, val);
        });
      } else {
        return val;
      }
    });
  } else {
    valueToUse = value;
  }

  var propsToUse = _extends({}, removeUnwantedProps(rest), {
    intent: intent,
    options: optsToUse,
    value: valueToUse,
    // closeOnSelect: !rest.multi,
    onChange: function onChange(valOrVals) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var valToPass, _len3, rest2, _key3, _ref6, stopEarly;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Array.isArray(valOrVals)) {
                  valToPass = valOrVals.map(function (val) {
                    if (val.userCreated) {
                      return val;
                    }

                    return val.value;
                  });
                } else if (valOrVals) {
                  if (valOrVals.userCreated) {
                    valToPass = valOrVals;
                  } else {
                    valToPass = valOrVals.value;
                  }
                } else {
                  valToPass = "";
                }

                if (!(props.cancelSubmit && props.cancelSubmit(valToPass))) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                for (_len3 = _arguments.length, rest2 = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                  rest2[_key3 - 1] = _arguments[_key3];
                }

                if (!beforeOnChange) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 7;
                return beforeOnChange.apply(void 0, [valToPass].concat(rest2));

              case 7:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 10;
                  break;
                }

                _context2.t0 = {};

              case 10:
                _ref6 = _context2.t0;
                stopEarly = _ref6.stopEarly;

                if (!stopEarly) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return");

              case 14:
                _onChange.apply(void 0, [valToPass].concat(rest2));

                if (!rest.submitOnBlur) onFieldSubmit(valToPass);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onBlur: function onBlur() {
      var valToPass = Array.isArray(valueToUse) ? valueToUse.filter(function (val) {
        return !!val;
      }).map(function (val) {
        return val.value;
      }) : valueToUse;

      if (props.cancelSubmit && props.cancelSubmit(valToPass)) {
        return; //allow the user to cancel the submit
      }

      if (rest.submitOnBlur) {
        onFieldSubmit(valToPass);
      }
    }
  });

  return /*#__PURE__*/React.createElement(TgSelect, propsToUse);
};
export var renderSuggest_old = function renderSuggest_old(props) {
  return renderReactSelect(_extends({}, props, {
    asSuggest: true
  }));
};
export var renderSuggest = function renderSuggest(props) {
  var async = props.async,
      _props$input2 = props.input,
      value = _props$input2.value,
      _onChange2 = _props$input2.onChange,
      hideValue = props.hideValue,
      intent = props.intent,
      options = props.options,
      onFieldSubmit = props.onFieldSubmit,
      rest = _objectWithoutPropertiesLoose(props, ["async", "input", "hideValue", "intent", "options", "onFieldSubmit"]);

  var propsToUse = _extends({}, removeUnwantedProps(rest), {
    intent: intent,
    options: options,
    value: value,
    onChange: function onChange(val) {
      _onChange2(val);

      if (!rest.submitOnBlur) onFieldSubmit(val);
    },
    onBlur: function onBlur() {
      if (rest.submitOnBlur) {
        onFieldSubmit(value);
      }
    }
  });

  return /*#__PURE__*/React.createElement(TgSuggest, propsToUse);
};
export var BPSelect = function BPSelect(_ref7) {
  var value = _ref7.value,
      onChange = _ref7.onChange,
      rest = _objectWithoutPropertiesLoose(_ref7, ["value", "onChange"]);

  return renderSelect(_extends({}, rest, {
    input: {
      onChange: onChange,
      value: value
    }
  }));
};
export var renderSelect = function renderSelect(props) {
  // spreading input not working, grab the values needed instead
  var _props$input3 = props.input,
      value = _props$input3.value,
      _onChange3 = _props$input3.onChange,
      hideValue = props.hideValue,
      className = props.className,
      placeholder = props.placeholder,
      onFieldSubmit = props.onFieldSubmit,
      options = props.options,
      hidePlaceHolder = props.hidePlaceHolder,
      minimal = props.minimal,
      disabled = props.disabled,
      rest = _objectWithoutPropertiesLoose(props, ["input", "hideValue", "className", "placeholder", "onFieldSubmit", "options", "hidePlaceHolder", "minimal", "disabled"]);

  return /*#__PURE__*/React.createElement("div", {
    className: (minimal && Classes.MINIMAL) + " " + classNames(Classes.SELECT, Classes.FILL, className)
  }, /*#__PURE__*/React.createElement("select", _extends({}, removeUnwantedProps(rest), {
    className: (disabled && Classes.DISABLED) + " ",
    value: placeholder && value === "" ? "__placeholder__" : typeof value !== "string" ? sortify(value) //deterministically sort and stringify the object/number coming in because select fields only support string values
    : value,
    disabled: disabled
  }, hideValue ? {
    value: ""
  } : {}, {
    onChange: function onChange(e) {
      var val = e.target.value;

      try {
        var maybeNewValue = JSON.parse(e.target.value); //try to json parse the string coming in

        var hasMatchInOriginalOptions = options.find(function (opt) {
          return opt === maybeNewValue || opt.value === maybeNewValue;
        });

        if (hasMatchInOriginalOptions || isPlainObject(maybeNewValue)) {
          val = maybeNewValue;
        }
      } catch (e) {//empty
      }

      _onChange3(val);

      onFieldSubmit && onFieldSubmit(val);
    }
  }), placeholder && /*#__PURE__*/React.createElement("option", {
    value: "__placeholder__",
    disabled: true,
    hidden: hidePlaceHolder
  }, placeholder), options.map(function (opt, index) {
    var label, value;

    if (typeof opt === "string") {
      //support passing opts like: ['asdf','awfw']
      label = opt;
      value = opt;
    } else if (isNumber(opt)) {
      //support passing opts like: [1,2,3,4]
      label = opt.toString();
      value = opt;
    } else if (Array.isArray(opt)) {
      throw new Error("the option coming in should be an object, not an array!");
    } else {
      //support passing opts the normal way [{label: 'opt1', value: 'hey'}]
      label = opt.label;
      value = opt.value;
    }

    return /*#__PURE__*/React.createElement("option", {
      key: index,
      value: typeof value !== "string" ? sortify(value) //deterministically sort and stringify the object/number coming in because select fields only support string values
      : value
    }, label);
  })));
};
export var renderBlueprintNumericInput = function renderBlueprintNumericInput(props) {
  var input = props.input,
      hideValue = props.hideValue,
      intent = props.intent,
      inputClassName = props.inputClassName,
      onFieldSubmit = props.onFieldSubmit,
      onAnyNumberChange = props.onAnyNumberChange,
      rest = _objectWithoutPropertiesLoose(props, ["input", "hideValue", "intent", "inputClassName", "onFieldSubmit", "onAnyNumberChange"]);

  function handleBlurOrButtonClick(stringVal) {
    if (rest.readOnly) return;

    try {
      var num = mathExpressionEvaluator.eval(stringVal);
      input.onBlur(num);
      onFieldSubmit(num);
    } catch (e) {
      console.error("TRC: Error occurring when setting evaluated numeric input field:", e);
      input.onBlur("");
      onFieldSubmit("");
    }
  }

  return /*#__PURE__*/React.createElement(NumericInput, _extends({
    value: input.value,
    intent: intent
  }, removeUnwantedProps(rest), hideValue ? {
    value: ""
  } : {}, {
    className: classNames(Classes.FILL, inputClassName),
    onValueChange: function onValueChange(numericVal, stringVal) {
      // needed for redux form to change value
      input.onChange(stringVal); //tnr: use this handler if you want to listen to all value changes!

      onAnyNumberChange && onAnyNumberChange(numericVal);
    },
    onButtonClick: function onButtonClick(numericVal, stringVal) {
      handleBlurOrButtonClick(stringVal);
    },
    onBlur: function onBlur(e) {
      handleBlurOrButtonClick(e.target.value);
    }
  }));
};
export var renderBlueprintRadioGroup = function renderBlueprintRadioGroup(_ref8) {
  var input = _ref8.input,
      options = _ref8.options,
      onFieldSubmit = _ref8.onFieldSubmit,
      rest = _objectWithoutPropertiesLoose(_ref8, ["input", "options", "onFieldSubmit"]);

  var optionsToUse = getOptions(options);
  return /*#__PURE__*/React.createElement(RadioGroup, _extends({}, input, removeUnwantedProps(rest), {
    selectedValue: input.value,
    label: undefined //removing label from radio group because our label already handles it
    ,
    onChange: function onChange(e, val) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      input.onChange.apply(input, [e, val].concat(args));
      onFieldSubmit(e.target ? e.target.value : val);
    },
    options: optionsToUse
  }));
};
export var RenderReactColorPicker = /*#__PURE__*/function (_React$Component3) {
  _inheritsLoose(RenderReactColorPicker, _React$Component3);

  function RenderReactColorPicker() {
    var _this3;

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this3 = _React$Component3.call.apply(_React$Component3, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this3), "handleChange", function (color) {
      var _this3$props = _this3.props,
          input = _this3$props.input,
          onFieldSubmit = _this3$props.onFieldSubmit;
      input.onChange(color.hex);
      onFieldSubmit(color.hex);
    });

    return _this3;
  }

  var _proto3 = RenderReactColorPicker.prototype;

  _proto3.render = function render() {
    var _this$props6 = this.props,
        input = _this$props6.input,
        onFieldSubmit = _this$props6.onFieldSubmit,
        rest = _objectWithoutPropertiesLoose(_this$props6, ["input", "onFieldSubmit"]);

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popover, {
      position: "bottom-right",
      minimal: true,
      modifiers: popoverOverflowModifiers,
      content: /*#__PURE__*/React.createElement(SketchPicker, _extends({
        className: "tg-color-picker-selector",
        color: input.value,
        onChangeComplete: this.handleChange
      }, removeUnwantedProps(rest)))
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        padding: "7px",
        margin: "1px",
        background: "#fff",
        borderRadius: "1px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
        display: "inline-block",
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "tg-color-picker-selected-color",
      style: {
        width: "36px",
        height: "14px",
        borderRadius: "2px",
        background: "" + input.value
      }
    }))));
  };

  return RenderReactColorPicker;
}(React.Component); // tgreen: This doesn't work because the async validate function will not be automatically rerun onSubmit
// class AddAsyncValidate extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       asyncValidating: false
//     };
//     this.runAsyncValidationDebounced = debounce(this.runAsyncValidation, 500);
//   }
//   componentDidUpdate(oldProps) {
//     const {
//       validateOnChange,
//       input: { name, value },
//       meta: { touched, form, dispatch }
//     } = this.props;
//     const newValue = value;
//     const oldValue = oldProps.input.value;
//     const valueHasChanged = newValue !== oldValue;
//     if (validateOnChange && valueHasChanged) {
//       this.runAsyncValidationDebounced(newValue);
//     }
//     // mark the input as touched after changing value
//     if (valueHasChanged && !touched) {
//       dispatch(touch(form, name));
//     }
//   }
//   triggerAsyncValidation(error) {
//     const {
//       input: { name },
//       meta: { dispatch, form },
//       formAsyncErrors
//     } = this.props;
//     // this needs to get a fresh prop for formAsyncErrors otherwise it will get out of sync.
//     // the test will catch this.
//     dispatch(
//       stopAsyncValidation(form, {
//         ...formAsyncErrors,
//         [name]: error
//       })
//     );
//   }
//   runAsyncValidation = async val => {
//     const {
//       input: { name },
//       meta: { dispatch, form },
//       asyncValidate
//     } = this.props;
//     this.setState({
//       asyncValidating: true
//     });
//     // mark this field as invalid so that the user can not submit this form while async validating
//     this.triggerAsyncValidation("asyncValidating");
//     dispatch(startAsyncValidation(form));
//     const error = await asyncValidate(val);
//     this.triggerAsyncValidation(error);
//     // if there is no error then clear it from redux
//     if (!error) {
//       dispatch(clearAsyncError(form, name));
//     }
//     this.setState({
//       asyncValidating: false
//     });
//     return error;
//   };
//   onBlur = (...args) => {
//     const { input } = this.props;
//     // always run this on input blur so that the user cannot submit a form with a field that has not finished validating
//     this.runAsyncValidation(input.value);
//     input.onBlur(...args);
//   };
//   render() {
//     const { asyncValidating } = this.state;
//     const {
//       passedComponent: Component,
//       input,
//       formAsyncErrors, // don't pass through
//       dispatch, // don't pass through
//       ...rest
//     } = this.props;
//     return (
//       <Component
//         {...rest}
//         input={{
//           ...input,
//           onBlur: this.onBlur
//         }}
//         asyncValidating={asyncValidating}
//       />
//     );
//   }
// }
// const WrappedAddAsyncValidate = connect((state, { meta }) => {
//   return {
//     formAsyncErrors: getFormAsyncErrors(meta.form)(state)
//   };
// })(AddAsyncValidate);

export function generateField(component, opts) {
  var compWithDefaultVal = withAbstractWrapper(component, opts);
  return function FieldMaker(_ref9) {
    var name = _ref9.name,
        isRequired = _ref9.isRequired,
        _ref9$onFieldSubmit = _ref9.onFieldSubmit,
        onFieldSubmit = _ref9$onFieldSubmit === void 0 ? noop : _ref9$onFieldSubmit,
        noRedux = _ref9.noRedux,
        rest = _objectWithoutPropertiesLoose(_ref9, ["name", "isRequired", "onFieldSubmit", "noRedux"]);

    var component = compWithDefaultVal;

    var props = _extends({
      onFieldSubmit: onFieldSubmit,
      name: name
    }, noRedux && {
      input: {
        onChange: rest.onChange || noop,
        onBlur: rest.onBlur || noop,
        value: rest.value,
        name: name
      }
    }, {
      component: component
    }, isRequired && {
      validate: fieldRequired
    }, {
      isRequired: isRequired
    }, rest); // if (asyncValidate) {
    //   props = {
    //     ...props,
    //     asyncValidate,
    //     component: WrappedAddAsyncValidate,
    //     passedComponent: component
    //   };
    // }


    return /*#__PURE__*/React.createElement(Field, props);
  };
}
export var withAbstractWrapper = function withAbstractWrapper(ComponentToWrap, opts) {
  if (opts === void 0) {
    opts = {};
  }

  return function (props) {
    var _generateDefaultValue;

    var massageDefaultIdValue = props.massageDefaultIdValue,
        generateDefaultValue = props.generateDefaultValue,
        defaultValueByIdOverride = props.defaultValueByIdOverride,
        defaultValueFromProps = props.defaultValue,
        isRequired = props.isRequired,
        rest = _objectWithoutPropertiesLoose(props, ["massageDefaultIdValue", "generateDefaultValue", "defaultValueByIdOverride", "defaultValue", "isRequired"]); //get is assign defaults mode
    //if assign default value mode then add on to the component


    var _React$useState = React.useState(0),
        defaultValCount = _React$useState[0],
        setDefaultValCount = _React$useState[1];

    var _useState3 = useState(),
        defaultValueFromBackend = _useState3[0],
        setDefault = _useState3[1];

    var _useState4 = useState(true),
        allowUserOverride = _useState4[0],
        setUserOverride = _useState4[1];

    var _useState5 = useState(false),
        isLoadingDefaultValue = _useState5[0],
        setLoadingDefaultValue = _useState5[1];

    var _useContext = useContext(AssignDefaultsModeContext),
        inAssignDefaultsMode = _useContext.inAssignDefaultsMode,
        setAssignDefaultsMode = _useContext.setAssignDefaultsMode; // tnr: we might want to grab this context object off the window in the future and have it live in lims by default
    // there is no reason for those vals to live in TRC. Example code below:
    // const workflowParams = useContext(window.__tgDefaultValParamsContext || defaultNullContext);


    var workflowParams = useContext(WorkflowDefaultParamsContext);
    var caresAboutToolContext = generateDefaultValue == null ? void 0 : (_generateDefaultValue = generateDefaultValue.params) == null ? void 0 : _generateDefaultValue.toolName;

    var customParamsToUse = _extends({}, caresAboutToolContext ? _extends({}, workflowDefaultParamsObj, workflowParams) : {}, generateDefaultValue ? generateDefaultValue.customParams : {});

    function triggerGetDefault() {
      return _triggerGetDefault.apply(this, arguments);
    } // if generateDefaultValue, hit the backend for that value


    function _triggerGetDefault() {
      _triggerGetDefault = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var doParamsMatch, _ref10, defaultValue, _allowUserOverride, massagedRes;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (defaultValueByIdOverride) {
                  _context3.next = 12;
                  break;
                }

                if (window.__triggerGetDefaultValueRequest) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                if (generateDefaultValue) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                setLoadingDefaultValue(true); //custom params should match params keys. if not throw an error

                doParamsMatch = isEqual(Object.keys(_extends({}, caresAboutToolContext ? workflowDefaultParamsObj : {}, generateDefaultValue.params || {})).sort(), Object.keys(customParamsToUse).sort());

                if (doParamsMatch) {
                  _context3.next = 12;
                  break;
                }

                console.warn("Issue with generateDefaultValue. customParams don't match params");
                console.warn("generateDefaultValue.params:", generateDefaultValue.params);
                console.warn("generateDefaultValue.customParams:", customParamsToUse);
                throw new Error("Issue with generateDefaultValue code=" + generateDefaultValue.code + ": Difference detected with: " + difference(Object.keys(generateDefaultValue.params || {}), Object.keys(customParamsToUse || {})).join(", ") + ". customParams passed into the field should match params (as defined in defaultValueConstants.js). See console for more details.");

              case 12:
                _context3.prev = 12;

                if (!defaultValueByIdOverride) {
                  _context3.next = 17;
                  break;
                }

                _context3.t0 = {
                  defaultValue: defaultValueByIdOverride
                };
                _context3.next = 20;
                break;

              case 17:
                _context3.next = 19;
                return window.__triggerGetDefaultValueRequest(generateDefaultValue.code, customParamsToUse);

              case 19:
                _context3.t0 = _context3.sent;

              case 20:
                _ref10 = _context3.t0;
                defaultValue = _ref10.defaultValue;
                _allowUserOverride = _ref10.allowUserOverride;

                if (!massageDefaultIdValue) {
                  _context3.next = 29;
                  break;
                }

                _context3.next = 26;
                return massageDefaultIdValue({
                  defaultValueById: defaultValue
                });

              case 26:
                massagedRes = _context3.sent;

                if (massagedRes.defaultValue) {
                  defaultValue = massagedRes.defaultValue;
                }

                if (massagedRes.preventUserOverrideFromBeingDisabled) {
                  _allowUserOverride = true;
                }

              case 29:
                if (ComponentToWrap === renderBlueprintCheckbox || ComponentToWrap === renderBlueprintSwitch) {
                  setDefault(defaultValue === "true");
                } else {
                  if (typeof defaultValue === "string") {
                    // remove double spaces and leading/trailing
                    defaultValue = defaultValue.replace(/\s+/g, " ").trim();
                  }

                  setDefault(defaultValue);
                }

                setUserOverride(_allowUserOverride);
                setDefaultValCount(defaultValCount + 1);
                _context3.next = 37;
                break;

              case 34:
                _context3.prev = 34;
                _context3.t1 = _context3["catch"](12);
                console.error("error aswf298f:", _context3.t1);

              case 37:
                if (!(window.Cypress && window.Cypress.addFakeDefaultValueWait)) {
                  _context3.next = 40;
                  break;
                }

                _context3.next = 40;
                return fakeWait();

              case 40:
                setLoadingDefaultValue(false);

              case 41:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[12, 34]]);
      }));
      return _triggerGetDefault.apply(this, arguments);
    }

    useDeepCompareEffect(function () {
      // if the input already has a value we don't want to override with the default value request
      if (rest.input.value) return;
      triggerGetDefault();
    }, [generateDefaultValue || {}]); // const asyncValidating = props.asyncValidating;

    var defaultProps = _extends({}, rest, {
      defaultValue: defaultValueFromBackend || defaultValueFromProps,
      disabled: props.disabled || allowUserOverride === false,
      readOnly: props.readOnly || isLoadingDefaultValue,
      intent: getIntent(props),
      intentClass: getIntentClass(props)
    }); // don't show intent while async validating
    // if (asyncValidating) {
    //   delete defaultProps.intent;
    //   delete defaultProps.intentClass;
    // }


    var startAssigningDefault = function startAssigningDefault() {
      return window.__showAssignDefaultValueModal && window.__showAssignDefaultValueModal(_extends({}, props, {
        generateDefaultValue: _extends({}, props.generateDefaultValue, {
          customParams: customParamsToUse
        }),
        onFinish: function onFinish() {
          triggerGetDefault();
        }
      }));
    };

    return /*#__PURE__*/React.createElement(AbstractInput, _extends({}, opts, {
      defaultValCount: defaultValCount,
      isRequired: isRequired
    }, defaultProps, {
      isLoadingDefaultValue: isLoadingDefaultValue,
      showGenerateDefaultDot: !inAssignDefaultsMode && window.__showGenerateDefaultDot && window.__showGenerateDefaultDot() && !!generateDefaultValue,
      setAssignDefaultsMode: setAssignDefaultsMode,
      startAssigningDefault: startAssigningDefault,
      assignDefaultButton: inAssignDefaultsMode && generateDefaultValue && /*#__PURE__*/React.createElement(Button, {
        onClick: startAssigningDefault,
        small: true,
        style: {
          background: "yellow",
          color: "black"
        }
      }, "Assign Default")
    }), /*#__PURE__*/React.createElement(ComponentToWrap, defaultProps));
  };
};
export var InputField = generateField(RenderBlueprintInput);
export var FileUploadField = generateField(renderFileUpload);
export var DateInputField = generateField(renderBlueprintDateInput);
export var DateRangeInputField = generateField(renderBlueprintDateRangeInput);
export var CheckboxField = generateField(renderBlueprintCheckbox, {
  noOuterLabel: true,
  noFillField: true
});
export var SwitchField = generateField(renderBlueprintSwitch, {
  noOuterLabel: true,
  noFillField: true
});
export var TextareaField = generateField(renderBlueprintTextarea);
export var SuggestField = generateField(renderSuggest);
export var EditableTextField = generateField(renderBlueprintEditableText);
export var NumericInputField = generateField(renderBlueprintNumericInput);
export var RadioGroupField = generateField(renderBlueprintRadioGroup, {
  noFillField: true
});
export var ReactSelectField = generateField(renderReactSelect);
export var SelectField = generateField(renderSelect);
export var ReactColorField = generateField(RenderReactColorPicker);

function getOptions(options) {
  return options && options.map(function (opt) {
    if (typeof opt === "string") {
      return {
        label: opt,
        value: opt
      };
    } else if (isNumber(opt)) return {
      label: opt.toString(),
      value: opt
    };

    return opt;
  });
}

function fakeWait() {
  var fakeWaitNum = isNumber(window.Cypress.addFakeDefaultValueWait) ? window.Cypress.addFakeDefaultValueWait : 3000;
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve();
    }, fakeWaitNum);
  });
}